module.exports = __webpack_public_path__ + "img/logo@2x.a6510216.png";